import { get } from 'lodash';
import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormResetContext } from 'src/pages/pmp/utils';
import ScanLossConfigGroup from 'src/pages/shared/ScanLossConfigGroup';

function ScanLossPMP(props) {
  const { getValues } = useFormContext();
  const resetValue = useContext(FormResetContext);
  const { setModified, ap, sm } = props;
  const pathIndex = props.pathIndex ?? 0;

  const calculateAttrPath = `radios.${pathIndex}.antennas.0.config.user_calculate_scan_loss`;
  const defaultValue = get(sm, calculateAttrPath);
  const frequencyMhz =
    // Preferred: the canonical frequency field in the form/state
    getValues(`radios.${pathIndex}.frequency.frequency_mhz`) ||
    get(sm, `radios.${pathIndex}.frequency.frequency_mhz`) ||
    get(ap, `radios.${pathIndex}.frequency.frequency_mhz`) ||
    // Back-compat: some configs use tx_frequency
    getValues(`radios.${pathIndex}.frequency.tx_frequency`) ||
    get(sm, `radios.${pathIndex}.frequency.tx_frequency`) ||
    get(ap, `radios.${pathIndex}.frequency.tx_frequency`);
  // Use AP frequency as a fallback when SM config/form is missing since SM shares frequency.

  return (
    <ScanLossConfigGroup
      pathIndex={pathIndex}
      frequencyMhz={frequencyMhz}
      calculateDefaultValue={defaultValue}
      setModified={setModified}
      formResetValue={resetValue}
    />
  );
}

export default ScanLossPMP;
